import { AudioLines, FileText, Film, Video } from "lucide-react"

export type MentionThumbIcon = "camera" | "audio" | "video" | "file"

const ICONS = { camera: Video, audio: AudioLines, video: Film, file: FileText } as const

/** Превью внутри чипа упоминания: иконка медиа или картинка. */
export function MentionThumb({ icon, imageUrl }: { icon: MentionThumbIcon | null; imageUrl: string }) {
  if (icon) {
    const Icon = ICONS[icon]
    return (
      <span className="pe-mention__thumb pe-mention__thumb--icon" aria-hidden>
        <Icon />
      </span>
    )
  }
  return <img className="pe-mention__thumb" src={imageUrl} alt="" draggable={false} />
}
